// Studyo Today Backend
// Package studyo.today.schedules.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/schedules.proto (package studyo.today.schedules.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_schedules_v1_resources_activity } from "./resources/activity_pb.js";
import { file_studyo_today_schedules_v1_resources_calendar } from "./resources/calendar_pb.js";
import { file_studyo_today_schedules_v1_resources_draft_schedule_cycle_summary } from "./resources/draft_schedule_cycle_summary_pb.js";
import { file_studyo_today_schedules_v1_resources_schedule_cycle } from "./resources/schedule_cycle_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/schedules.proto.
 */
export const file_studyo_today_schedules_v1_schedules = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_type_date, file_studyo_today_schedules_v1_resources_activity, file_studyo_today_schedules_v1_resources_calendar, file_studyo_today_schedules_v1_resources_draft_schedule_cycle_summary, file_studyo_today_schedules_v1_resources_schedule_cycle]);

/**
 * Describes the message studyo.today.schedules.v1.GetCalendarRequest.
 * Use `create(GetCalendarRequestSchema)` to create a new message.
 */
export const GetCalendarRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 0);

/**
 * Describes the message studyo.today.schedules.v1.GetCalendarResponse.
 * Use `create(GetCalendarResponseSchema)` to create a new message.
 */
export const GetCalendarResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 1);

/**
 * Describes the message studyo.today.schedules.v1.GetScheduleCycleRequest.
 * Use `create(GetScheduleCycleRequestSchema)` to create a new message.
 */
export const GetScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 2);

/**
 * Describes the message studyo.today.schedules.v1.GetScheduleCycleResponse.
 * Use `create(GetScheduleCycleResponseSchema)` to create a new message.
 */
export const GetScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 3);

/**
 * Describes the message studyo.today.schedules.v1.PublishInitialScheduleCycleRequest.
 * Use `create(PublishInitialScheduleCycleRequestSchema)` to create a new message.
 */
export const PublishInitialScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 4);

/**
 * Describes the message studyo.today.schedules.v1.PublishInitialScheduleCycleResponse.
 * Use `create(PublishInitialScheduleCycleResponseSchema)` to create a new message.
 */
export const PublishInitialScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 5);

/**
 * Describes the message studyo.today.schedules.v1.SaveDraftScheduleCycleRequest.
 * Use `create(SaveDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const SaveDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 6);

/**
 * Describes the message studyo.today.schedules.v1.SaveDraftScheduleCycleResponse.
 * Use `create(SaveDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const SaveDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 7);

/**
 * Describes the message studyo.today.schedules.v1.PublishDraftScheduleCycleRequest.
 * Use `create(PublishDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const PublishDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 8);

/**
 * Describes the message studyo.today.schedules.v1.PublishDraftScheduleCycleResponse.
 * Use `create(PublishDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const PublishDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 9);

/**
 * Describes the message studyo.today.schedules.v1.DiscardLastDraftScheduleCycleRequest.
 * Use `create(DiscardLastDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const DiscardLastDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 10);

/**
 * Describes the message studyo.today.schedules.v1.DiscardLastDraftScheduleCycleResponse.
 * Use `create(DiscardLastDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const DiscardLastDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 11);

/**
 * Describes the message studyo.today.schedules.v1.DiscardAllDraftScheduleCyclesRequest.
 * Use `create(DiscardAllDraftScheduleCyclesRequestSchema)` to create a new message.
 */
export const DiscardAllDraftScheduleCyclesRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 12);

/**
 * Describes the message studyo.today.schedules.v1.DiscardAllDraftScheduleCyclesResponse.
 * Use `create(DiscardAllDraftScheduleCyclesResponseSchema)` to create a new message.
 */
export const DiscardAllDraftScheduleCyclesResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 13);

/**
 * Describes the message studyo.today.schedules.v1.CopyScheduleCycleRequest.
 * Use `create(CopyScheduleCycleRequestSchema)` to create a new message.
 */
export const CopyScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 14);

/**
 * Describes the message studyo.today.schedules.v1.CopyScheduleCycleResponse.
 * Use `create(CopyScheduleCycleResponseSchema)` to create a new message.
 */
export const CopyScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 15);

/**
 * Describes the message studyo.today.schedules.v1.DeleteScheduleCycleRequest.
 * Use `create(DeleteScheduleCycleRequestSchema)` to create a new message.
 */
export const DeleteScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 16);

/**
 * Describes the message studyo.today.schedules.v1.CreateDemoSchoolSnapshotRequest.
 * Use `create(CreateDemoSchoolSnapshotRequestSchema)` to create a new message.
 */
export const CreateDemoSchoolSnapshotRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 17);

/**
 * Describes the message studyo.today.schedules.v1.RestoreDemoSchoolSnapshotRequest.
 * Use `create(RestoreDemoSchoolSnapshotRequestSchema)` to create a new message.
 */
export const RestoreDemoSchoolSnapshotRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_schedules, 18);

/**
 * The Today gRPC service for manipulating persisted schedules and generating calendar information.
 *
 * @generated from service studyo.today.schedules.v1.Schedules
 */
export const Schedules = /*@__PURE__*/
  serviceDesc(file_studyo_today_schedules_v1_schedules, 0);

